var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-features"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 mb-4 mb-md-0 p-3"},[_c('div',{staticClass:"w-75 mx-auto",domProps:{"innerHTML":_vm._s(_vm.features)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }